import React, { useEffect, useState, useCallback } from 'react';
import { useThrottleFn } from 'ahooks';

export const Text = React.memo((props) => {
  const { title, name, value, placeholder, onChange } = props;
  const [innerValue, setInnerValue] = useState(value);
  const onChangeThrottled = useThrottleFn(onChange, { wait: 300 });

  const handleChange = useCallback(
    (e) => {
      setInnerValue(e.target.value);
      onChangeThrottled.run(e.target.value, name);
    },
    [onChangeThrottled, name],
  );

  useEffect(() => {
    setInnerValue(value);
  }, [value]);

  return (
    <div className="leading-0">
      <div className="mb-1">
        <span className="text-xs text-[#7f7f7f] leading-[14px]">{title}</span>
      </div>
      <input
        value={innerValue}
        onChange={handleChange}
        placeholder={placeholder || `请输入${title}`}
        className="w-full h-8 px-3 text-xs leading-[14px] text-[#2d2d2d] bg-[#f9fbfb] border border-[#eee] rounded focus:border-primary"
      />
    </div>
  );
});

export const TextView = React.memo((props) => {
  const { title, value } = props;
  return (
    <>
      <div className="p-4">
        <h5 id="model-checkpoints-entry" className="text-[#2d2d2d] text-xs  leading-[14px] font-bold font-gro">
          {title}
        </h5>
        <span className="mt-3 block text-[#2d2d2d] text-xs font-normal">{value}</span>
      </div>
      <div className="border-t border-[#efefef]" />
    </>
  );
});
